export default __webpack_public_path__ + "static/data-about-screenshot-1--mobile-7569b4ec51f90bfad8a626a936dda399.png";